import script from "./TitleHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleHeader.vue?vue&type=script&setup=true&lang=js"

import "./TitleHeader.vue?vue&type=style&index=0&id=162ad014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162ad014"]])

export default __exports__